<template lang="pug">
#home
  .hero.is-large(style="background-image:url('/images/cwo/hero.jpg')")
    .container.mobile-padding
      h1.is-size-1-desktop.is-size-3-touch {{ account.tagline }}
      .ctas
        a
          span About Cornerstone
        router-link(:to="{ name: 'ministries' }")
          span Our Ministries
        router-link(:to="{ name: 'projects' }")
          span Special Projects
    scroll-indicator(v-if="!isMobile")
  .content-block
    .container.mobile-padding
      p.is-size-5 Cornerstone World Outreach is a Christian congregation in Sioux City, Iowa. It Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

  .content-block(v-if="events.length > 0")
    .container
      .content-block-header.mobile-padding
        h3 Upcoming events
      .columns
        .column.is-one-third(
          v-for="event in events"
          :key="event.id"
        )
          event-list-item(
            :value="event"
            :hoverable="false"
            :limit="2"
          )

  .content-block(v-if="projects.length > 0")
    .container
      .content-block-header.mobile-padding
        h3 Special projects
      .columns
        .column.is-one-third(
          v-for="project in projects"
          :key="project.id"
        )
          event-list-item(
            :value="event"
            mode="project"
          )

  .hero(style="background-image:url('/images/cwo/teaching-02.jpg')")
    .container.mobile-padding
      h1.is-size-1 Solid, biblical teaching.
      .ctas
        router-link(:to="{ name: 'believe' }")
          span What we Believe
        router-link(:to="{ name: 'services' }")
          span Watch our Services
        router-link(:to="{ name: 'staff' }")
          span Pastoral Staff

  .content-block(v-if="collections.length > 0")
    .container
      .content-block-header.mobile-padding
        h3 Featured series
        router-link(:to="{ name: 'services', query: { tab: 'series' } }") All Series
      .columns
        .column.is-one-third(
          v-for="collection in collections"
          :key="collection.id"
        )
          collection-list-item(
            :hoverable="true"
            :value="collection"
          )

  .content-block(v-if="episodes.length > 0")
    .container
      .content-block-header.mobile-padding
        h3 Recent sermons
        router-link(:to="{ name: 'services', query: { tab: 'sermons' } }") All Sermons
      .columns
        .column.is-one-third(
          v-for="episode in episodes"
          :key="episode.id"
        )
          episode-list-item(
            :hoverable="true"
            :value="episode"
          )

  .content-block
    .container
      .content-block-header.mobile-padding
        h3 Latest articles
      .columns.is-multiline
        .column.is-one-third(
          v-for="article in articles"
          :key="article.id"
        )
          article-list-item(
            :value="article"
          )

  .hero(style="background-image:url('/images/cwo/heartland.jpg')")
    .container
      h1.is-size-1 Touching America&rsquo;s heartland.
      .ctas
        a
          span About Sioux City, Iowa
        a
          span Driving Directions

  .map-block.content-block
    .container
      .columns
        .column.is-half
          google-map(
            :location="account._embedded.location"
            :name="account._embedded.location.id"
          )
        .column.is-half
          .mobile-padding
            h3 Our services
            service-list-item(
              v-for="service in account._embedded.services"
              :key="service.id"
              :value="service"
            )
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import { SEARCH } from '@/utils/http';
import ArticleListItem from '@/components/articles/ArticleListItem.vue';
import CollectionListItem from '@/components/collections/CollectionListItem.vue';
import EpisodeListItem from '@/components/episodes/EpisodeListItem.vue';
import EventListItem from '@/components/events/EventListItem.vue';
import GoogleMap from '@/components/GoogleMap.vue';
import ScrollIndicator from '@/components/ScrollIndicator.vue';
import ServiceListItem from '@/components/ministries/ServiceListItem.vue';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'home',
  components: {
    ArticleListItem,
    CollectionListItem,
    EpisodeListItem,
    EventListItem,
    GoogleMap,
    ScrollIndicator,
    ServiceListItem,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
    }),
    articlesQuery() {
      const payload = {
        size: 6,
        sort: [
          { pub_date: 'desc' },
          { 'title.raw': { order: 'asc' } },
          '_score',
        ],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
              { match: { is_published: true } },
              { range: { pub_date: { lte: this.today } } },
            ],
          },
        },
      };
      return payload;
    },
    collectionsQuery() {
      const payload = {
        size: 3,
        sort: [
          { is_featured: { order: 'asc' } },
          { start_date: { order: 'desc' } },
          '_score',
        ],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
              { range: { episode_count: { gte: 1 } } },
            ],
          },
        },
      };
      return payload;
    },
    episodesQuery() {
      const payload = {
        size: 3,
        sort: [
          { pub_date: { order: 'desc' } },
          '_score',
        ],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
            ],
            filter: [
              { term: { is_published: true } },
              { range: { pub_date: { lte: this.today } } },
            ],
          },
        },
      };
      return payload;
    },
    eventsQuery() {
      const payload = {
        size: 3,
        sort: [
          { end_date: { order: 'asc' } },
          { 'title.raw': { order: 'asc' } },
          '_score',
        ],
        query: {
          bool: {
            must: [
              { match: { type: 'event' } },
              { match: { account_id: this.account.id } },
              { match: { is_published: true } },
              { range: { pub_date: { lte: this.today } } },
              { range: { end_date: { gte: this.today } } },
            ],
          },
        },
      };
      return payload;
    },
    isMobile() {
      return window.innerWidth <= 769;
    },
    projectsQuery() {
      const payload = {
        size: 3,
        sort: [
          { pub_date: 'desc' },
          { 'title.raw': { order: 'asc' } },
          '_score',
        ],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
              { match: { is_published: true } },
              { range: { pub_date: { lte: this.today } } },
              { match: { type: 'project' } },
            ],
          },
        },
      };
      return payload;
    },
  },
  async created() {
    this.settings.loading = true;
    this.today = moment().format('YYYY-MM-DD');
    this.month = moment().startOf('month').format('YYYY-MM-DD');
    await Promise.all([
      this.getArticles(),
      this.getCollections(),
      this.getEpisodes(),
      this.getEvents(),
    ]);
    this.settings.loading = false;
  },
  data() {
    return {
      articles: [],
      collections: [],
      episodes: [],
      events: [],
      month: null,
      projects: [],
      settings: {
        loading: false,
      },
      today: null,
    };
  },
  methods: {
    async getArticles() {
      const { data } = await SEARCH.post('/doxa_articles/_search', this.articlesQuery);
      this.articles = data.hits.hits.map(h => h._source);
      return data;
    },
    async getCollections() {
      const { data } = await SEARCH.post('/doxa_episode_collections/_search', this.collectionsQuery);
      this.collections = data.hits.hits.map(h => h._source);
      return data;
    },
    async getEpisodes() {
      const { data } = await SEARCH.post('/doxa_episodes/_search', this.episodesQuery);
      this.episodes = data.hits.hits.map(h => h._source);
      return data;
    },
    async getEvents() {
      const { data } = await SEARCH.post('/doxa_events/_search', this.eventsQuery);
      this.events = this.sortEvents(data.hits.hits.map(h => h._source));
      return data;
    },
    sortEvents(events) {
      const today = moment();
      return _.sortBy(events, (e) => {
        const filtered = _.filter(e.dates, (d) => {
          const date = moment(d, 'YYYY-MM-DD');
          return date.isSameOrAfter(today, 'day');
        });
        return _.min(filtered);
      });
    },
  },
};
</script>

<style theme="cwo" lang="scss">
#home {
  margin-top: calc(#{$navbar-height} * -1);
  .hero {
    @include hero;
    &.is-large {
      height: 100vh;
    }
    .container {
      align-items: center;
      display: flex;
      flex-flow: column;
      justify-content: center;
    }
    .ctas {
      justify-content: center;
      margin-top: 2.5rem;
      a {
        padding: 0 0.75rem;
        font-size: 1.2rem;
        span {
          border-bottom: 2px solid transparent;
        }
        &:hover {
          color: $primary;
          span {
            border-bottom: 2px solid $primary;
          }
        }
      }
    }
  }
  .content-block {
    margin: 4.5rem 0;
    .content-block-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      a {
        @include link;
        margin-bottom: 0.75rem;
      }
    }
    h3 {
      font-family: $heading-font;
      font-weight: 500;
      font-size: 1.25rem;
      margin-bottom: 0.75rem;
    }
    .google-map {
      height: 400px;
    }
  }
  @media (max-width: $tablet) {
    .hero {
      background-attachment: inherit;
      background-position: center;
      background-size: cover;
      .ctas {
        margin-top: 1.5rem;
        display: flex;
        flex-flow: column;
        a {
          font-size: 1.1rem;
        }
        a + a {
          padding-top: 1rem;
        }
      }
    }
    .hero {
      .container {
        h1 {
          margin-bottom: 0;
        }
      }
    }
    .content-block {
      margin: 2.5rem 0;
      &:not(.map-block) {
        .columns {
          @include carousel;
        }
      }
    }
  }
}
</style>
